module.exports = __webpack_public_path__ + "img/button_home.f51e7605.svg";